import { Range } from "@pdfking/tfunc"

/** The days of the week from Monday, short, in `language`: from 1 January
 * 2001, a Monday. */
export const WeekdayNames = (language: string): string[] => {
  const format = new Intl.DateTimeFormat(language, { timeZone: "UTC", weekday: "short" })
  return [...Range(7)].map(day => format.format(Date.UTC(2001, 0, 1 + day)))
}
